import React from 'react'
import { useSeo } from '../../lib/i18n'

export default function ValgAfKoereskoleEn() {
  useSeo({
    title: 'Choosing a Driving School | Borgs Driving School Kalundborg',
    description: 'Helpful advice before choosing a driving school. Read about educational quality, pricing, and student rights.',
    lang: 'en',
    pathname: '/en/choosing-a-driving-school'
  })

  return (
    <div className="bg-slate-50 min-h-screen py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-8 sm:p-12 border border-slate-200 shadow-sm space-y-8">
          <div>
            <h1 className="font-header text-3xl sm:text-4xl font-extrabold text-slate-900">
              Choosing a Driving School
            </h1>
            <p className="mt-2 text-slate-900 font-bold text-lg">
              Good advice before selecting your driving school
            </p>
            <p className="mt-1 text-slate-700">
              There are several important factors worth considering before you make your choice.
            </p>
          </div>

          <div className="space-y-6 text-slate-700 leading-relaxed">
            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                Cheap can turn out expensive
              </h2>
              <p>
                When taking your driving licence, it is all about choosing a school that teaches you to drive safely. As a new driver, you deserve the best possible preparation. Price and quality often go hand in hand, so do not let price alone be your only deciding factor. Intense price competition among driving schools can lead to varying instructional quality.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                Listen to recommendations from others
              </h2>
              <p>
                It is always wise to listen to the experiences of past students. If you know someone who was pleased with their driving instructor, chances are you will be too.
              </p>
              <p>
                (With me, you are welcome to visit Facebook and see if there are former or current students you know whom you can ask directly).
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                Speak with the driving instructor
              </h2>
              <p>
                Taking your driving licence is built on mutual trust. That is why it is a great idea to speak with your instructor before committing. Assess whether the instructor seems sensible, dedicated, and professional.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                Find out what the price includes
              </h2>
              <p>
                Many places offer starter packages. Check carefully what is included. Confirm whether the package contains all mandatory lessons required to take the driving test, whether test fees and car rental during the practical test are included, or if unexpected costs may arise later. At Borgs Driving School, the mandatory package contains the necessary statutory training.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                You can switch driving instructors during your training
              </h2>
              <p>
                If you are unfortunate and dissatisfied with your instruction, you always have the right to switch to another driving school. Note that refunding package deals depends on terms, so speak with the school about this if needed.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                Appeals and complaints regarding driving instruction
              </h2>
              <p>
                If you are dissatisfied with your driver training, you can lodge a complaint with the Danish Driving Instruction Appeals Board ({' '}
                <a
                  href="http://www.ankesag.dk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-emerald-700 font-bold hover:underline"
                >
                  http://www.ankesag.dk/
                </a>
                {' '}). The board handles cases across all driving instructors in Denmark. A complaint costs 150 DKK, which is refunded if you win or partially win your case.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}
